import { render, staticRenderFns } from "./AdminOps.vue?vue&type=template&id=73d6ad37&"
import script from "./AdminOps.vue?vue&type=script&lang=ts&"
export * from "./AdminOps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports